import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { BoatsSchema, BoatSchema } from '../models/boat'

const getBoats = async () => {
  const res = await axios.get('/api/boats')
  return BoatsSchema.parse(res.data)
}

const getBoat = async (boatId: number) => {
  const res = await axios.get(`/api/boats/${boatId}`)
  return BoatSchema.parse(res.data)
}

export const useBoats = () => {
  return useQuery({
    queryKey: ['boats'],
    queryFn: getBoats,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useBoat = (boatId: number) => {
  return useQuery({
    queryKey: ['boat', boatId],
    queryFn: () => getBoat(boatId),
    enabled: !!boatId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
